import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 's7currency'
})
export class S7CurrencyPipe implements PipeTransform {
  constructor(private ngCurrency: CurrencyPipe, @Inject(LOCALE_ID) public readonly localeId: string) {}

  /**
   *
   * @param value - выводимое значение
   * @param currencyCode - A string containing the currency symbol or its name,
   * such as "$" or "Canadian Dollar". Used in output string, but does not affect the operation
   * of the function.
   * @param display - The format for the currency indicator
   * @param digitsInfo Decimal representation options, specified by a string in the following format:
   * `{minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}`. See `DecimalPipe` for more details.
   */
  transform(
    value: any,
    currencyCode?: string,
    display?: 'code' | 'symbol' | 'symbol-narrow' | string | boolean,
    digitsInfo?: string
  ): string {
    let truncatedValue = value;

    // Если копейки не должны отображаться, то просто отрезаем их без округления (для использования совместно с CentsPipe
    const hasCentsDisplayed = !digitsInfo || /\..*[1-9]/.test(digitsInfo);
    if (!hasCentsDisplayed) {
      const parsedValue = typeof value === 'number' ? value : parseFloat(value);
      truncatedValue = !isNaN(parsedValue) ? parsedValue : value;
      truncatedValue = !isNaN(truncatedValue) ? Math.trunc(parsedValue) : value;
    }

    if (this.ngCurrency == null) {
      return '';
    }
    return (
      this.ngCurrency
        .transform(truncatedValue, currencyCode, display, digitsInfo, this.localeId ?? 'ru')
        ?.replace(/\s/g, ' ') // заменяем пробел на ТОНКИЙ пробел
        .replace('-', '−') ?? // заменяем дефис на ЗНАК МИНУСА
      ''
    );
  }
}
